<app-dashboard>
  <div class="w-full flex flex-col p-[20px]">
    <div (click)="navigateTo('customers')" class="w-fit flex gap-[5px] cursor-pointer items-center pb-[20px]">
      <img src="../../../assets/icons/chevron-left2.svg" alt="" /><span class="text-[14px] text-slate-700 font-[500]"
        >Back</span
      >
    </div>
    <div
      class="w-full flex flex-col lg:grid lg:grid-cols-3 gap-[10px] border rounded-[8px] p-[20px]"
    >
      <div class="w-full flex gap-[10px] items-center">
        <app-avatar [round]="false" [text]="'Ameh Kedonojo'" [size]="'50'" />
        <div class="w-full flex flex-col justify-center">
          <span class="text-[18px] font-[700] text-slate-800">AMEH KEDONOJO</span>
          <div class="flex items-center gap-[5px]">
            <span class="font-[800] text-slate-500 text-[10px]"
              >Customer Id:
              <span class="text-[14px] font-[400] text-slate-800"
                >9389djeueeduded45</span
              ></span
            >
            <img
              (click)="copyToClipboard('9389djeueeduded45')"
              class="w-[10px] h-[10px] cursor-pointer"
              src="../../../assets/icons/copy-text.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w-full col-span-1 flex flex-col justify-center">
        <div class="flex items-center gap-[5px]">
          <span class="text-[12px] font-[400] text-[#64748B]"
            >Referral Code : </span
          ><span class="font-[800] text-[16px] text-[#364152]">UpRzvV</span
          ><img
            (click)="copyToClipboard('UpRzvV')"
            class="w-[10px] h-[10px] cursor-pointer"
            src="../../../assets/icons/copy-text.svg"
            alt=""
          />
        </div>
        <div class="flex items-center gap-[5px]">
          <span class="text-[12px] font-[400] text-[#64748B]"
            >Rewards Earned : </span
          ><span class="font-[800] text-[16px] text-[#364152]">47</span>
        </div>
        <div class="flex items-center gap-[5px]">
          <span class="text-[12px] font-[400] text-[#64748B]"
            >Total Transactions : </span
          ><span class="font-[800] text-[16px] text-[#364152]">30</span>
        </div>
      </div>
      <div class="w-full flex items-center gap-[10px]">
        <img class="w-[30px] h-[30px]" src="../../../assets/icons/coins.png" alt="">
        <span class="text-[30px] font-[600] text-slate-800"
          >736
          <span class="text-[14px] text-slate-500 font-[700]"
            >pts. earned</span
          ></span
        >
      </div>
    </div>
    <div class="w-full flex flex-col mt-[30px]">
      <div class="w-full flex border-b items-center gap-[20px]">
        <span
          (click)="setActivetab(tab)"
          *ngFor="let tab of tabHeaders"
          class="pb-[5px] text-[14px] cursor-pointer {{
            activeTab === tab
              ? 'border-b-[2px] border-[#081A46] text-[#081A46] font-[800]'
              : 'text-slate-500 font-[400]'
          }}"
          >{{ tab }}</span
        >
      </div>
      <div *ngIf="activeTab === 'Monthly Transaction'"></div>
      <div *ngIf="activeTab === 'Reward Transaction'"></div>
    </div>
  </div>
</app-dashboard>
<p>
  total transactions monthly, reward transactions, total points received, total
  rewards earned
</p>
